import React, { useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { teams } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import MultiSelectPrimary from '../MultiSelectPrimary';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../common/StaticExports';
import TurfAutocomplete from '../TurfAutocomplete';
import IlluminationAutocomplete from '../IlluminationAutocomplete';
import { deleteGround } from '../../api/dataCapture';
import { useSelector } from 'react-redux';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const GroundDetailsTable = (props?: any) => {
    const { data, addData, handleClick, updateList } = props;
    const [t] = useTranslation();
    const [newData, setNewData]: any = useState({});
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {key: '', displayName: t('NAME')},
    {key: '', displayName: t('DC_6_WIDTH')},
    {key: '', displayName: t('DC_6_DEPTH')},
    {key: '', displayName: t('DC_6_SPECTATORS')},
    {key: '', displayName: t('DC_6_TURF')},
    {key: '', displayName: t('ILLUMINATION')},
    {key: '', displayName: ''}
  ]

  const manageCreatenew = () => {
    if (newData?.name) {
      const updatedList = [{...newData, tempId: Math.random()}, ...data];
      updateList(updatedList);
      setNewData({});
      handleClick();
    }
  }
  
  const manageDeleteRow = (row: any) => {
    if (row?.id) {
      deleteGround({ clubId: clubDetails?.id, id: row?.id });
    }
    const updatedList = data?.filter((d:any) => d?.id != row?.id || d?.tempId != row?.tempId);
    updateList(updatedList);
  }

  const manageChange = (row: any) => {
    const updatedList = data?.map((d:any) => d?.id == row?.id ? row : d);
    updateList(updatedList);
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                      {
                        !isAdmin && addData &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-add-data`}
                        >
                            <TableCell className='fs12'>
                              <TextField variant='standard' sx={{ width: '100%' }} value={newData?.name} onChange={(e) => setNewData({ ...newData, name: e.target.value })} error={isEmpty(newData?.name)} helperText={isEmpty(newData?.name) ? t('REQUIRED') : ''} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={newData?.width} onChange={(e) => setNewData({ ...newData, width: parseInt(e.target.value) })} error={isEmpty(newData?.width)} helperText={isEmpty(newData?.width) ? t('REQUIRED') : ''} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={newData?.depth} onChange={(e) => setNewData({ ...newData, depth: parseInt(e.target.value) })} error={isEmpty(newData?.depth)} helperText={isEmpty(newData?.depth) ? t('REQUIRED') : ''} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={newData?.spectators} onChange={(e) => setNewData({ ...newData, spectators: parseInt(e.target.value) })} error={isEmpty(newData?.spectators)} helperText={isEmpty(newData?.spectators) ? t('REQUIRED') : ''} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <TurfAutocomplete selectedValues={newData?.turf ? newData?.turf : []} manageSelect={(e:any) => {setNewData({ ...newData, turf: e })}} isError={isEmpty(newData?.turf)} errorMessage={t('REQUIRED')} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <IlluminationAutocomplete selectedValues={newData?.illumination ? newData?.illumination : []} manageSelect={(e:any) => {setNewData({ ...newData, illumination: e })}}  />
                            </TableCell>
                            <TableCell>
                                <Tooltip title='Delete' arrow placement='top'>
                                  <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                                </Tooltip>
                                <Tooltip title='Create' arrow placement='top'>
                                  <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                              <TextField variant='standard' sx={{ width: '100%' }} value={d?.name} onChange={(e) => manageChange({ ...d, name: e.target.value })} error={isEmpty(d?.name) && !isAdmin} helperText={isEmpty(d?.name) && !isAdmin ? t('REQUIRED') : ''} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={d?.width} onChange={(e) => manageChange({ ...d, width: parseInt(e.target.value) })} error={isEmpty(d?.width) && !isAdmin} helperText={isEmpty(d?.width) && !isAdmin ? t('EQUIRED') : ''} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={d?.depth} onChange={(e) => manageChange({ ...d, depth: parseInt(e.target.value) })} error={isEmpty(d?.depth) && !isAdmin} helperText={isEmpty(d?.depth) && !isAdmin ? t('REQUIRED') : ''} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <TextField variant='standard' type='number' sx={{ width: '100%' }} value={d?.spectators} onChange={(e) => manageChange({ ...d, spectators: parseInt(e.target.value) })} error={isEmpty(d?.spectators) && !isAdmin} helperText={isEmpty(d?.spectators) && !isAdmin ? t('REQUIRED') : ''} disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <TurfAutocomplete selectedValues={d?.turf ? d?.turf : []} manageSelect={(e:any) => {manageChange({ ...d, turf: e })}} isError={isEmpty(d?.turf) && !isAdmin} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                              <IlluminationAutocomplete selectedValues={d?.illumination ? d?.illumination : []} manageSelect={(e:any) => {manageChange({ ...d, illumination: e })}} isReadOnly={isAdmin}  />
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {!isAdmin && manageDeleteRow(d)}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default GroundDetailsTable;